import { debounce } from '../../core/helpers';
import keepSameHeightTitles from './keepSameHeightTitles';
import { initSelectNewColor } from './selectNewColor';
import { initMarketingBlock, resizeMarketingBlocks } from './marketingBlock';
import initSEO from './seo';
import initSubCategoriesMenu from './subCategoriesMenu';
import initSmartBanner from '../smart-banner';
import initThirdLevelURL from './third-level-url';
import { initFilteredCollection } from './filteredCollection';
import VideoTiles from './videoTiles';
import ProductTilesWishlist from '../../components/wishlist/product-tiles';

// This is happening AFTER loading the Nosto collection called from theme.js
export default async () => {
  if (document.querySelector('.template-plp') === null) {
    return;
  }

  // We resize the marketing blocks first to avoid layout shifts when loading product tiles
  resizeMarketingBlocks();

  new ProductTilesWishlist(); // needs to be before initFilteredCollection() since it includes a listener init in initFilteredCollection()
  new VideoTiles();
  initSubCategoriesMenu();
  initSmartBanner();
  initSelectNewColor();
  initThirdLevelURL();
  initMarketingBlock(); // needs to be after initThirdLevelURL()
  await initFilteredCollection();

  keepSameHeightTitles();
  initSEO();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pagination-back-to-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  window.addEventListener('resize', debounce(() => {
    keepSameHeightTitles();
  }, 100));
};
